import { render, staticRenderFns } from "./FooterSigner.vue?vue&type=template&id=3a36879a&"
import script from "./FooterSigner.vue?vue&type=script&lang=js&"
export * from "./FooterSigner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports